
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Cart } from "@/types/Cart";
import WizardCartWindow from "@/views/_components/WizardCartWindow.vue";

const { State } = namespace("Root");

@Component({
  components: {
    WizardCartWindow,
  },
})
export default class QuickCartPreviewMobile extends Vue {
  @State("cart") cart!: Cart;
  show_cart = false;

  mounted() {
    this.hideCart();
  }

  hideCart() {
    const modal = this.$refs.cart as any;
    if (modal) {
      modal.hide();
    }
  }

  showCart() {
    const modal = this.$refs.cart as any;
    if (modal) {
      modal.show();
    }
  }
}
